import main from './main'

main.$mount('#app')